export const imgBaseURL = "/mainsys/UserFiles/coverpic/";

export const loginStatusConfig = new Map([
  [-1, "您的账号已被管理员锁定"],
  [-2, "您的账号在审核状态中，请耐心等待"],
  [-3, "用户名或密码错误"],
  [-4, "验证码错误"],
  ["default", "与服务器断连接"],
]); 
